<template>
	<div class="cos">
		<!-- <naviBack title="" type="nav1" background="#FFFFFF" /> -->
		
		<div class="co_success">
			<img class="co_success_icon" src="../resource/pay_success.png" alt="" />
			<div class="co_success_title">已收到预约，待平台确认</div>
			<div class="co_success_block">
				<!-- <div class="co_success_block_title font_weight">预约信息</div> -->
				<div class="co_success_block_stitle">预约课程：预约课程预约课程预约课程</div>
				<div class="co_success_block_stitle">到店时间：到店时间到店时间</div>
				<div class="co_success_block_stitle">预约门店：预约门店预约门店</div>
			</div>
			<div class="co_success_btn">预约记录</div>
		</div>
		
	</div>
</template>
<script>
	import naviBack from '../components/navi_back.vue';
	export default {
		components: {
			naviBack
		},
		data() {
			return {
				
			}
		},
		mounted() {
			console.log(this.$route);
		},
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.co_success {
		width: 100%;
		padding: 120*@vm_base 125*@vm_base 40*@vm_base 125*@vm_base;
		text-align: center;
	
		.co_success_icon {
			width: 160*@vm_base;
			margin: 0 auto;
		}
	
		.co_success_title {
			width: 100%;
			text-align: center;
			font-size: 36*@vm_base;
			color: #F77F28;
			margin-top: 100*@vm_base;
		}
	
		.co_success_block {
			width: 100%;
			color: #333333;
			text-align: left;
			margin-top: 48*@vm_base;
			padding: 0 34*@vm_base;
	
	
			.co_success_block_stitle {
				font-size: 30*@vm_base;
				margin-top: 24*@vm_base;
				color: #666666;
				white-space: nowrap;
			}
		}
	
		.co_success_btn {
			width: 100%;
			height: 80*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 32*@vm_base;
			border-radius: 40*@vm_base;
			background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
			color: #fff;
			margin: 0 auto;
			margin-top: 100*@vm_base;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/success.vue